module.exports = __webpack_public_path__ + "static/media/books-medical.9d90bcb7.svg";